export default {
    methods: {
        mxFormatarData(data) {
            if (!data) {
                return '- -';
            }

            const partes = data.split('-');
            const ano = partes[2];
            const dia = partes[1];
            const mes = partes[0];

            return `${dia}/${mes}/${ano}`;

        }
    }
};
